export default __webpack_public_path__ + "static/4-89b713410545b1e3477fb67222397165.jpeg";